import { colors } from './tokens';

export const palette = {
    mode: 'dark',
    primary: {
        main: colors.primary[500],
        light: colors.primary[400],
        dark: colors.primary[600],
        contrastText: '#ffffff',
    },
    secondary: {
        main: colors.primary[400],
        light: colors.primary[300],
        dark: colors.primary[500],
    },
    background: {
        default: colors.surface.base,
        paper: colors.surface.raised,
    },
    text: {
        primary: colors.text.primary,
        secondary: colors.text.secondary,
        disabled: colors.text.disabled,
    },
    divider: colors.border.subtle,
    success: {
        main: colors.performance.positive,
        light: '#4ade80',
        dark: '#16a34a',
    },
    error: {
        main: colors.performance.negative,
        light: '#f87171',
        dark: '#dc2626',
    },
    warning: {
        main: '#f59e0b',
    },
    action: {
        hover: 'rgba(255,255,255,0.04)',
        selected: 'rgba(255,255,255,0.08)',
        disabled: 'rgba(255,255,255,0.3)',
        disabledBackground: 'rgba(255,255,255,0.08)',
    },
    // Custom extensions — accessed via theme.palette.custom.*
    custom: {
        surface: colors.surface,
        border: colors.border,
        text: colors.text,
        performance: colors.performance,
        direction: colors.direction,
        party: colors.party,
        status: colors.status,
        primary: colors.primary,
    },
};
